import api from '../../plugins/api';

//Ð¾ÑÐ¼ÐµÐ½Ð¸ÑÑ Ð·Ð°ÑÐ²ÐºÑ Ñ ÑÐ¸Ð½Ð°Ð½ÑÐ¸ÑÐ¾Ð²Ð°Ð½Ð¸ÐµÐ¼
const cancelLoanApplication = ({ bankOwnerId, chunkId }) => {
  return api.post('/api/bank/cancelLoanApplication', { sourceId: bankOwnerId, chunkId });
};

export default cancelLoanApplication;
